import {ApiRequestConfig} from '../../types';

export class ApiRequestBuilder {
  private apiRequestConfig: ApiRequestConfig = {
    endpointId: '',
    body: {},
    recaptchaCode: '',
    auth2FACode: '',
    replaceUrl: {},
    cookiesData:[
      {
        cookieId: 'CookieScriptConsent',
        propertyId: 'key',
        asId: 'CookieScriptConsentKey'
      }
    ],
    options: {
      showLoading: false,
      showError: false
    }
  };
  constructor(endpointId?: string) {
    if (endpointId) {
      this.setEndpoint(endpointId);
    }
  }

  public setEndpoint(endpointId: string): ApiRequestBuilder {
    this.apiRequestConfig.endpointId = endpointId;
    return this;
  }

// tslint:disable-next-line:no-any
  public setBody(body: Record<string, any>): ApiRequestBuilder {
    this.apiRequestConfig.body = body;
    return this;
  }
  public setBodyProperty(key: string, value: any): ApiRequestBuilder {
    if (!this.apiRequestConfig.body) {
      this.apiRequestConfig.body = {};
    }
    this.apiRequestConfig.body[key] = value;
    return this;
  }
// tslint:disable-next-line:no-any
  public replaceUrl(replaceUrl: Record<string, any>): ApiRequestBuilder {
    this.apiRequestConfig.replaceUrl = replaceUrl;
    return this;
  }

  public setRecaptchaCode(recaptchaCode: string): ApiRequestBuilder {
    this.apiRequestConfig.recaptchaCode = recaptchaCode;
    return this;
  }

  public setAuth2FACode(auth2FACode: string): ApiRequestBuilder {
    this.apiRequestConfig.auth2FACode = auth2FACode;
    return this;
  }

  public showLoading(): ApiRequestBuilder {
    this.apiRequestConfig.options.showLoading = true;
    return this;
  }

  public showError(): ApiRequestBuilder {
    this.apiRequestConfig.options.showError = true;
    return this;
  }

  public build(): ApiRequestConfig {
    return this.apiRequestConfig;
  }
}
